<template>
	<button
		type="button"
		class="p-1 shrink-0"
		@click="toggleBold"
		:title="$t('Bold')"
		tabindex="-1"
		:class="{
			active: isActive,
			'bg-indigo-200 rounded-md': isActive,
		}"
	>
		<BoldIcon class="w-5 h-5" />
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { BoldIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "BoldButton",
	components: { BoldIcon },
	props: {
		editor: { type: Object as PropType<any>, required: false },
	},
	computed: {
		isActive(): boolean {
			return !!(this.editor as any)?.isActive?.("bold");
		},
	},
	methods: {
		toggleBold() {
			(this.editor as any)?.chain?.().focus().toggleBold().run();
		},
	},
});
</script>
